export enum NOTIFICATION_TYPE {
	CASE = 'CASE',
	MESSAGE = 'MESSAGE',
	LINK = 'LINK',
	DOCUMENTATION_FILE = 'DOCUMENTATION_FILE',
}
